export default __webpack_public_path__ + "static/media/tutorial-01.054c70fd.png";